import * as DSAssetFamilies from './DSAssetFamilies';

// This file contains the subset of asset families that are also filter
// families, it is for access convinience and should never contain a string that
// isn't a DSAssetFamily
export const ADS_PROPERTY = DSAssetFamilies.ADS_PROPERTY;
export const COMPANY_PROPERTY = DSAssetFamilies.COMPANY_PROPERTY;
export const CONTACT_IMPORT = DSAssetFamilies.CONTACT_IMPORT;
export const CONTACT_LIST = DSAssetFamilies.CONTACT_LIST;
export const CONTACT_PROPERTY = DSAssetFamilies.CONTACT_PROPERTY;
export const CTA = DSAssetFamilies.CTA;
export const DEAL_PROPERTY = DSAssetFamilies.DEAL_PROPERTY;
export const EMAIL_CAMPAIGN = DSAssetFamilies.EMAIL_CAMPAIGN;
export const EMAIL_SUBSCRIPTION = DSAssetFamilies.EMAIL_SUBSCRIPTION;
export const ENGAGEMENT_PROPERTY = DSAssetFamilies.ENGAGEMENT_PROPERTY;
export const EVENT = DSAssetFamilies.EVENT;
export const FORM = DSAssetFamilies.FORM;
export const GOTO_WEBINAR_WEBINAR = DSAssetFamilies.GOTO_WEBINAR_WEBINAR;
export const INTEGRATION = DSAssetFamilies.INTEGRATION;
export const LINE_ITEM_PROPERTY = DSAssetFamilies.LINE_ITEM_PROPERTY;
export const PAGE_VIEW = DSAssetFamilies.PAGE_VIEW;
export const PRODUCT_PROPERTY = DSAssetFamilies.PRODUCT_PROPERTY;
export const SURVEY_MONKEY_SURVEY = DSAssetFamilies.SURVEY_MONKEY_SURVEY;
export const SURVEY_MONKEY_QUESTION = DSAssetFamilies.SURVEY_MONKEY_QUESTION;
export const WORKFLOW = DSAssetFamilies.WORKFLOW;